// @ts-nocheck
/**
 * Current user info already stored at login, for APM labels.
 * @returns {{ username?: string, id?: string|number, email?: string }}
 */
export const getSessionUserLabels = () => {
  try {
    const raw = localStorage.getItem('user_data');
    const user = raw ? JSON.parse(raw) : null;
    return {
      username: user?.username,
      id: user?.id,
      email: user?.email,
    };
  } catch (_error) {
    return {};
  }
};

/**
 * Start a custom APM transaction and attach the current session labels.
 * @param {string} [name='SessionExpired:continue'] - Transaction name.
 * @returns {Object|null} Transaction to end later, or null when APM is unavailable.
 */
export const startContinueTransaction = (name = 'SessionExpired:continue') => {
  if (!window.apm?.startTransaction) {
    return null;
  }
  const transaction = window.apm.startTransaction(name, 'custom');
  if (!transaction) {
    return null;
  }
  transaction.addLabels({
    action: 'opened',
    timestamp: new Date().toISOString(),
    ...getSessionUserLabels(),
  });
  return transaction;
};

/**
 * Record an outcome and close a custom APM transaction.
 * @param {Object|null} transaction - Transaction returned by startContinueTransaction.
 * @param {string} action - How the flow ended, such as yes, no, or dismissed.
 * @returns {void}
 */
export const endContinueTransaction = (transaction, action) => {
  if (!transaction) {
    return;
  }
  transaction.addLabels({
    action,
    timestamp: new Date().toISOString(),
  });
  transaction.end();
};
